import {GetExamsAuthorizationParams} from 'domain/usecases';
import {makeGetExamsAuthorization} from 'main/factories/usecases';

export async function getExamAuthorization(params: GetExamsAuthorizationParams) {
	const response = await makeGetExamsAuthorization().get(params);

	return {
		autorizaAgendamento: response?.authorized,
	};
}
